<template>
  <budgets-list
    :budgets="budgets"
    :mentor="false"
    :showOverlay="showOverlay"
    @add="add"
    @save="save"
    @cancel="cancel"
  ></budgets-list>
</template>

<script>
import BudgetsList from "@/components/tools/budgets/BudgetsList"
import User from "@/lib/user"

export default {
  components: {
    BudgetsList
  },
  computed: {
    budgets() {
      let budgets = this.$store.getters["budgets/getBudgets"]
      return budgets ? budgets : []
    }
  },
  data() {
    return {
      showOverlay: false
    }
  },
  created() {
    this.$store.dispatch("budgets/loadBudgets")
  },

  methods: {
    add() {
      this.showOverlay = true
    },
    async save(name) {
      let budget = await this.$store.dispatch("budgets/addBudget", {
        name: name,
        user_id: User.getUserId()
      })
      this.showOverlay = false
      this.$router.push({
        name: "budgetView",
        params: { budgetId: budget.id },
        query: { edit: true }
      })
    },
    cancel() {
      this.name = ""
      this.showOverlay = false
    }
  }
}
</script>
